var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 411,
    viewBox: "0 0 608 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000476837 227.361L227.361 357.362V410H-0.000488281L-0.000476837 227.361Z",
    fill: "url(#paint0_linear_439_733)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.857 -0.00012207L608 130.002V410H390.857V-0.00012207Z",
    fill: "url(#paint1_linear_439_733)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.857 0L608 130.053L228 357.647L0 227.594L390.857 0Z",
    fill: "url(#paint2_linear_439_733)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_733",
    x1: 112.514,
    y1: 229.087,
    x2: 119.102,
    y2: 763.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_733",
    x1: 390.857,
    y1: 59.5841,
    x2: 498.98,
    y2: 525.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506866,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_733",
    x1: 108.571,
    y1: 292.62,
    x2: 482.541,
    y2: 58.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2F2F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterDesign);
export default __webpack_public_path__ + "static/media/FooterDesign.1219cb8f450c636530e043d13ba53de0.svg";
export { ForwardRef as ReactComponent };